import { blockUI } from 'angular';

export function CoreBlockUIConfig (
  blockUIConfig : blockUI.BlockUIConfig
) {
  blockUIConfig.autoBlock           = false;
  blockUIConfig.autoInjectBodyBlock = false;
}